import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceTaxRatesEntityState} from "../reducers/ecommerce-tax-rates.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceTaxRatesState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceTaxRates.entities[websiteId]);

export const getEcommerceTaxRates = (websiteId: number) => createSelector(getEcommerceTaxRatesState(websiteId),
  (state: IEcommerceTaxRatesEntityState) => {
    return state?.data ? state.data : [];
  }
);

export const getEcommerceTaxRatesLoading = (websiteId: number) => createSelector(getEcommerceTaxRatesState(websiteId),
  (state: IEcommerceTaxRatesEntityState) => state && state.loading
);

export const getEcommerceTaxRatesLoaded = (websiteId: number) => createSelector(getEcommerceTaxRatesState(websiteId),
  (state: IEcommerceTaxRatesEntityState) => state && state.loaded
);
